import { render, staticRenderFns } from "./main.vue?vue&type=template&id=fc5cee0e&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5cee0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc5cee0e')) {
      api.createRecord('fc5cee0e', component.options)
    } else {
      api.reload('fc5cee0e', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=fc5cee0e&scoped=true", function () {
      api.rerender('fc5cee0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/landing-page/view/components/setting-prize/main.vue"
export default component.exports